import React from 'react';
import { Link } from "react-router-dom";
import * as ROUTES from '../routes/routes';
import $ from 'jquery';
import { Menu, Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';
import whitelogo from '../assets/images/whitelogo.svg';
import logo from '../assets/images/logo.svg';
import user_img from '../assets/images/user_img.png';
import profile_img from '../assets/images/icons/profile-img.svg';
import booking_history from '../assets/images/icons/booking-history.svg';
import logout from '../assets/images/logout.png';
import edit_icon from '../assets/images/edit_icon.svg';
import product1 from '../assets/images/seller_product/slider/product1.jpg';
import product2 from '../assets/images/seller_product/slider/product2.jpg';
import proceedcart from '../assets/images/proceed_cart.svg';
import search from '../assets/images/search.png';




class Headermain extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            qty: 0
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        //MENU CLOSE FUNCTION
        function menu_close() {
            $('.sidebar-wrapper').removeClass('active');
            $('.hamburger-menu-inner').removeClass('change');
            $('.overlay').hide();
        }
        //HAMBURGER MENU OF USER PANEL
        $('.hamburger-menu-inner').on('click', function () {
            if ($(this).hasClass('change')) {
                $('.overlay').hide();
                $('.sidebar-wrapper').removeClass('active');
                $('body').removeClass('sidebar-overlay');
                $(this).removeClass('change');
            }
            else {
                $('.overlay').show();
                $('.sidebar-wrapper').addClass('active');
                $('body').addClass('sidebar-overlay');
                $(this).addClass('change');
            }
        });
        $('.sidebar-overlay').on('click', function () {
            console.log('clicked');
            $('.sidebar-wrapper').removeClass('active');
            $('body').removeClass('sidebar-overlay');
        });
    }
    changeQty = (e, action) => {
        let qty = this.state.qty;
        if (action === 'plus') {
            qty = parseInt(qty) + parseInt(1);
        } else {
            if (qty > 0) {
                qty = parseInt(qty) - parseInt(1);
            }
        }
        this.setState({
            qty: qty
        })
    }
    render() {
        const menu = (
            <Menu
              items={[
                {
                  label: <div className="current-location-box">
                            <div className="current-location-title-area">
                                <div className="current-location-title-box">
                                    <p className="current-location-title">Current Location</p>
                                </div>
                            </div>
                            <div className="location-link-box">
                                <a href="" className="location-link">Detect Using GPS</a>
                            </div>
                        </div>
                ,
                  key: '0',
                },
                {
                  label: <div className="search-location-area">
                            <div className="search-location-box">
                                <input type="text" className="search-input-field common-input-field" placeholder="Search for location" />
                            </div>
                        </div>,
                  key: '1',
                }
              ]}
            />
          );
        return (
            <>
                <div className="">
                {/* className={(this.props.prop.location.pathname == ROUTES.PRODUCTS || this.props.prop.location.pathname == ROUTES.SELLER_SEARCH) ? "header-inner-white" : ''} id={(this.props.prop.location.pathname == ROUTES.PRODUCTS || this.props.prop.location.pathname == ROUTES.SELLER_SEARCH) ? "whitebox" : ''} */}
                    <header className="header">
                        <div className="header-wrapper">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12 header-content">
                                        <div className="whitelogo-stores">
                                            <Link to={ROUTES.HOME} title=" " className="site-logo">
                                                <img src={whitelogo} className="white-logo" alt=" " />
                                                <img src={logo} className="read-logo" alt=" " />
                                            </Link>
                                        </div>
                                        {/* <Link to={ROUTES.SELLER_SEARCH} title="All Stores" className={(this.props.prop.location.pathname == ROUTES.PRODUCTS || this.props.prop.location.pathname == ROUTES.SELLER_SEARCH || this.props.prop.location.pathname == ROUTES.VENDOR_LISTING) ? "d-none" : 'stores'}><i className="far fa-angle-left"></i>All Stores</Link> */}

                                        {/* <div class={(this.props.prop.location.pathname == ROUTES.PRODUCTS || this.props.prop.location.pathname == ROUTES.SELLER_SEARCH) ? "d-none" : 'search'}>
                                            <img src={search} alt="Search" />
                                            <input type="text" className="form-control" placeholder="Search Warephase" />
                                        </div> */}

                                        <div className="banner-dropdown-search-box-wrapper use-loaction-header">
                                            <div className="banner-dropdown-search-area">
                                                <div className="banner-location-dropdown">
                                                    <Dropdown overlay={menu} ClassName="location-dropdown" trigger={['click']} onClick={(e) => e.preventDefault()}>
                                                        <a onClick={(e) => e.preventDefault()}>
                                                        <Space>
                                                            Select Location
                                                            <DownOutlined />
                                                        </Space>
                                                        </a>
                                                    </Dropdown>
                                                </div>
                                                <div className="banner-search-input-box" onClick={(e) => e.preventDefault()}>
                                                    <span className="search-icon-box">
                                                        <img src={search} alt="" />
                                                    </span>
                                                    <input type="text" className="serach-input-field" placeholder="Search your Preferred Lab or Test" />
                                                </div>
                                            </div>
                                        </div>

                                        <ul className="right-wrapper">
                                            {/* <li className="location-dropdown dropdown">
                                                <Link title="Location" className="location dropdown-toggle" id="dropdownMenuLink1"
                                                    data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i className="fas fa-map-marker-alt"></i>Graham Road
                                                    <i className="far fa-angle-down"></i>
                                                </Link>
                                                <div className="dropdown-menu" aria-labelledby="dropdownMenuLink2">
                                                    <Link className="current-location dropdown-item" title="Use Current Location">
                                                        <img src={currentlocation} alt="Location" className="location-icon" />
                                                        <h5>Use Current Location</h5>
                                                    </Link>
                                                    <span className="separator"></span>
                                                    <div className="location-wrapper dropdown-item">
                                                        <img src={searchlocation} alt="Search" />
                                                        <input id="location_search" type="text" name="name" className="form-control"
                                                            placeholder="Search your location" required="required" />
                                                    </div>
                                                </div>
                                            </li> */}
                                            <li className="user-dropdown dropdown">
                                                <Link title="User" className="user dropdown-toggle" id="dropdownMenuLink2"
                                                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    <img src={user_img} alt="Vishal Gupta" />
                                                    <div className="user-detail">
                                                        <span className="username">Vishal Gupta</span>
                                                        {/* <span className="company">Globex Industries</span> */}
                                                    </div>
                                                    <i className="far fa-angle-down"></i>
                                                </Link>
                                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink2">
                                                    <li className={(this.props.prop.location.pathname == ROUTES.ACCOUNT_SETTINGS) ? "active " : ''}>
                                                        <Link to={ROUTES.ACCOUNT_SETTINGS} title="My Profile" className="dropdown-item">
                                                            <div className="image-box">
                                                                <img src={profile_img} alt="My Profile" />
                                                            </div>
                                                            <div className="title-text">
                                                                <span>My Profile</span>
                                                            </div>
                                                        </Link>
                                                    </li>
                                                    <li className={(this.props.prop.location.pathname == ROUTES.Booking_History) ? "active " : ''}>
                                                        <Link to={ROUTES.Booking_History} title="Booking History" className="dropdown-item">
                                                            <div className="image-box">
                                                                <img src={booking_history} alt="Booking History" />
                                                            </div>
                                                            <div className="title-text">
                                                                <span>Booking History</span>
                                                            </div>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link title="Logout" to={ROUTES.HOME} className="dropdown-item">
                                                            <div className="image-box">
                                                                <img src={logout} alt="Logout" />
                                                            </div>
                                                            <div className="title-text">
                                                                <span>Logout</span>
                                                            </div>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <Link to={ROUTES.CHECKOUT} title="Cart" className="cart">
                                                    <i className="far fa-shopping-cart"></i>
                                                    <div className="counter">
                                                        <span>2</span>
                                                    </div>
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="inner-header sticky-header">
                            <div>
                                <div className="">
                                    <div className="hamburger_active active">
                                        <span className="hamburger-menu-inner">
                                            <span className="bar1"></span>
                                            <span className="bar2"></span>
                                            <span className="bar3"></span>
                                        </span>
                                    </div>
                                </div>
                                <Link to={ROUTES.HOME} title=" " className="site-logo">
                                    <img src={logo} alt=" " />
                                </Link>
                                <div className="right-icon">
                                    {/* <div className={(this.props.prop.location.pathname == ROUTES.PRODUCTS || this.props.prop.location.pathname == ROUTES.SELLER_SEARCH) ? "d-none" : 'search-dropdown dropdown'}>
                                        <Link title="Search" className="search dropdown-toggle" id="dropdownMenuLink3"
                                            data-bs-toggle="dropdown" aria-expanded="false">
                                            <i className="far fa-search"></i>
                                        </Link>
                                        <div className="dropdown-menu" aria-labelledby="dropdownMenuLink3">
                                            <div className="search">
                                                <img src={searchlocation} alt="Search" />
                                                <input type="text" className="form-control" placeholder="Search Warephase" />
                                            </div>
                                        </div>
                                    </div> */}
                                    <Link to={ROUTES.CHECKOUT} title="Cart" className="cart">
                                        <i className="far fa-shopping-cart"></i>
                                        <div className="counter">
                                            <span>2</span>
                                        </div>
                                    </Link>

                                </div>
                                <span className="separator"></span>
                                {/* <Link to={ROUTES.SELLER_SEARCH} title="All Stores" className="stores">
                                    <i className="far fa-angle-left"></i>All Stores</Link> */}
                                <div className="location-dropdown dropdown">
                                    {/* <Link title="Location" className="location dropdown-toggle" id="dropdownMenuLink1"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="fas fa-map-marker-alt"></i>Graham Road
                                        <i className="far fa-angle-down"></i>
                                    </Link> */}
                                    {/* <div className="banner-location-dropdown mob-location-dropdown">
                                        <Dropdown overlay={menu} ClassName="location-dropdown" trigger={['click']}>
                                            <a onClick={(e) => e.preventDefault()}>
                                            <Space>
                                                Select Location
                                                <DownOutlined />
                                            </Space>
                                            </a>
                                        </Dropdown>
                                    </div> */}
                                    {/* <div className="dropdown-menu" aria-labelledby="dropdownMenuLink2">
                                        <Link className="current-location dropdown-item" title="Use Current Location">
                                            <img src={currentlocation} alt="Location" className="location-icon" />
                                            <h5>Use Current Location</h5>
                                        </Link>
                                        <span className="separator"></span>
                                        <div className="location-wrapper dropdown-item">
                                            <img src={searchlocation} alt="Search" />
                                            <input id="location_search" type="text" name="name" className="form-control"
                                                placeholder="Search your location" required="required" />
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="side_menu_header">
                                {/* <Slidemenu prop={this.props} /> */}
                            </div>
                        </div>
                    </header>
                    
                </div>
                {/* modal */}
                <div className="modal product-modal" id="cartModal" tabIndex="-1" aria-labelledby="exampleModalLabel"
                    aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">My Cart</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="proceed-btns">
                                    <div>
                                        <Link className="common-btn edit-card-btn" title="Edit Cart">
                                            <img src={edit_icon} alt="Edit" />
                                            Edit Cart</Link>
                                    </div>
                                    <div>
                                        <Link className="common-btn dark-pink-bg" title="Proceed to Buy">
                                            <img src={proceedcart}
                                                alt="Proceed Buy" />Proceed to Buy</Link>
                                    </div>
                                </div>
                                <h5>Total Price: &#36;15.18</h5>
                                <div className="product-info">
                                    <div className="item-img">
                                        <img src={product1} alt="img" />
                                    </div>
                                    <div className="item-text">
                                        <p>1/2" Straight Steel / Malleable Iron Connector </p>
                                        <div className="quantity-sec">
                                            <div className="part-box">
                                                <div>
                                                    <span>Part No.: 65259630</span>
                                                </div>
                                            </div>
                                            <div>
                                                <h5>&#36; 8.61</h5>
                                            </div>
                                        </div>
                                        <div className="product-quantity">
                                            <input type="button" value="-" className="qtyminus" field="quantity7" onClick={(e) => this.changeQty(e, "minus")} />
                                            <input type="text" name="quantity7" value={this.state.qty} className="qty" />
                                            <input type="button" value="+" className="qtyplus" field="quantity7" onClick={(e) => this.changeQty(e, "plus")} />
                                        </div>
                                    </div>
                                </div>
                                <div className="product-info">
                                    <div className="item-img">
                                        <img src={product2} alt="img" />
                                    </div>
                                    <div className="item-text">
                                        <p>1/2" Steel Cable Connector Hubbell</p>
                                        <div className="quantity-sec">
                                            <div className="part-box">
                                                <div>
                                                    <span>Part No.: 26563015</span>
                                                </div>
                                            </div>
                                            <div>
                                                <h5>&#36; 6.50</h5>
                                            </div>
                                        </div>
                                        <div className="product-quantity">
                                            <input type="button" value="-" className="qtyminus" field="quantity8" onClick={(e) => this.changeQty(e, "minus")} />
                                            <input type="text" name="quantity8" value={this.state.qty} className="qty" />
                                            <input type="button" value="+" className="qtyplus" field="quantity8" onClick={(e) => this.changeQty(e, "plus")} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Headermain;